import React, { useState, Fragment, useEffect } from "react";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { useHistory, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
const AssessmentSilly = ({
  assessment,
  forceUpdate,
  setRestartKey,
  done,
  viewAssessment,
  restartKey,
  setDone,
  setPlay,
  isAuthenticated,
  updatePMAssessmentResult,
  assessmentResults,
  deletePMResult,
  clearResult,
  user,
  setValidationChecklist,
  setStartAssessment,
}) => {
  const hist = useHistory();
  const location = useLocation();

  //get params

  const format = (data) => {
    let arr = [];

    for (let i = 0; i < data.Body.split(",").length / data.Groups; i++) {
      arr.push(i * data.Groups);
    }

    return arr;
  };

  const zeros = (arr) => {
    let r = [];
    for (let i = 0; i < arr.length; i++) {
      r.push(0);
    }
    return r;
  };

  const sum = (id) => {
    let sum = 0;
    const arr = soundsLength;
    for (let i = 0; i < id; i++) {
      sum += parseInt(arr[i]);
    }
    return sum;
  };

  const countRow = (id) => {
    if (id === 0) return 0;
    return soundsLength
      .slice(0, id * assessment.Groups)
      .reduce((a, b) => parseInt(a) + parseInt(b), 0);
  };

  const combine = (id, forward, i) => {
    let temp = [...sounds];
    let templabel = [...soundsLabel];
    let tempLength = [...soundsLength];
    if (forward) {
      // Combine current + next letter
      temp[id] = temp[id] + temp[id + 1];
      temp.splice(id + 1, 1);

      // ✅ Check if both letters have the same status
      const currentLabel = parseInt(templabel[id]);
      const nextLabel = parseInt(templabel[id + 1]);

      // ✅ Only preserve score if BOTH letters have identical status
      if (currentLabel === nextLabel) {
        templabel[id] = templabel[id]; // Keep the same status
      } else {
        templabel[id] = "0"; // Different statuses = no score
      }
      templabel.splice(id + 1, 1);
    } else {
      // ✅ Combine previous + current letter
      temp[id] = temp[id - 1] + temp[id];
      temp.splice(id - 1, 1);

      // ✅ Check if both letters have the same status
      const prevLabel = parseInt(templabel[id - 1]);
      const currentLabel = parseInt(templabel[id]);

      // ✅ Only preserve score if BOTH letters have identical status
      if (prevLabel === currentLabel) {
        templabel[id - 1] = templabel[id - 1]; // Keep the same status
      } else {
        templabel[id - 1] = "0"; // Different statuses = no score
      }

      setCombinedLetters((prev) => new Set([...prev, id]));
      templabel.splice(id - 1, 1);
    }
    // ✅ Update word length (reduce by 1)
    tempLength[i] = parseInt(tempLength[i]) - 1 + "";
    setSoundsLength(tempLength);
    setSoundsLabel(templabel);
    setSounds(temp);
  };

  const separate = (arr, ind, i) => {
    let temp = [...sounds];
    let templabel = [...soundsLabel];
    let tempLength = [...soundsLength];
    temp[ind] = arr[0];
    for (let i = 1; i < arr.length; i++) {
      if (parseInt(templabel[ind]) === 4) {
        temp.splice(ind + i, 0, arr[i]);
        templabel.splice(ind + i, 0, 0);
      } else {
        temp.splice(ind + i, 0, arr[i]);
        templabel.splice(ind + i, 0, templabel[ind]);
      }
    }
    tempLength[i] = parseInt(tempLength[i]) + arr.length - 1 + "";

    // ✅ Remove from combined tracking since we're separating
    setCombinedLetters((prev) => {
      const newSet = new Set(prev);
      newSet.delete(ind);
      return newSet;
    });

    setSoundsLength(tempLength);
    setSoundsLabel(templabel);
    setSounds(temp);
  };

  const validateEndMark = (results) => {
    if (results.includes("4")) {
      setValidationChecklist((prev) => {
        return prev?.map((item) => {
          if (item.desc === "Placed end mark") {
            return { ...item, checked: true };
          }
          return item;
        });
      });
    } else {
      setValidationChecklist((prev) => {
        return prev?.map((item) => {
          if (item.desc === "Placed end mark") {
            return { ...item, checked: false };
          }
          return item;
        });
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // New Calculation - Use Raw Score
    const totalScoreCLS = values.totalCLS;
    const totalScoreWWR = values.totalWWR;

    let data = {
      ...assessmentResults,
      CLS: cls.join(","),
      WWR: wwr.join(","),
      TotalCLS: values.totalCLS,
      TotalWWR: values.totalWWR,
      CategoryID: assessment.CategoryID,
      Comment: comment,
      TotalScore: parseInt(
        totalScoreCLS + "" + ("00" + totalScoreWWR).slice(-3),
      ),
      Year: assessmentResults.year,
      Sounds: sounds,
      SoundsIndex: soundsLabel,
      SoundsLength: soundsLength,
      CreatedDate: new Date().toISOString(),
    };

    // Validate if end mark added
    const endMarkAdded = soundsLabel.includes("4");

    if (!endMarkAdded) {
      setShowWarning(true);
      return;
    }
    setShowWarning(false);
    updatePMAssessmentResult(data).then(() => {
      setDone(true);
      setPlay(false);
      setStartAssessment(false);
    });
  };

  const [sounds, setSounds] = useState(
    assessmentResults.Sounds !== null
      ? assessmentResults.Sounds.split(",")
      : assessment.Body.split(","),
  );

  const [soundsLength, setSoundsLength] = useState(
    assessmentResults.SoundsLength !== null
      ? assessmentResults.SoundsLength.split(",")
      : () => {
          let arr = [];
          const body = assessment.Body.split(",");
          for (let i = 0; i < body.length; i++) {
            arr.push(1);
          }
          return arr;
        },
  );

  const [soundsLabel, setSoundsLabel] = useState(
    assessmentResults.SoundsIndex !== null
      ? assessmentResults.SoundsIndex.split(",")
      : zeros(assessment.Body.split(",")),
  );

  const [cls, setCLS] = useState(() => {
    if (!assessmentResults.CLS) return [];

    return assessmentResults.CLS.split(",").map((value) => {
      const parsed = parseInt(value, 10);
      return isNaN(parsed) ? 0 : parsed;
    });
  });

  const [wwr, setWWR] = useState(() => {
    if (!assessmentResults.WWR) return [];

    return assessmentResults.WWR.split(",").map((value) => {
      const parsed = parseInt(value, 10);
      return isNaN(parsed) ? 0 : parsed;
    });
  });

  const [rowCount, setRowCount] = useState();

  const [values, setValues] = useState({
    totalCLS:
      assessmentResults.TotalCLS !== null ? assessmentResults.TotalCLS : 0,
    totalWWR:
      assessmentResults.TotalWWR !== null ? assessmentResults.TotalWWR : 0,
  });

  const [wordCorrectness, setWordCorrectness] = useState([]);

  const [checkBox, setCheckbox] = useState([]);

  const [comment, SetComment] = useState(
    assessmentResults.Comment !== null ? assessmentResults.Comment : "",
  );

  const [doneCurrent, setDoneCurrent] = useState(
    location.pathname.includes("/assessment/preview/"),
  );

  const [showWarning, setShowWarning] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [combinedLetters, setCombinedLetters] = useState(new Set());

  // Initial Effect: Split words into letters and Initialize CLS and WWR
  useEffect(() => {
    const shouldSplitIntoLetters = () => {
      if (!assessment || !assessment.Body) return false;

      // Check if we already have saved data
      if (
        assessmentResults.soundsLabel &&
        assessmentResults.soundsLabel !== null &&
        assessmentResults.soundsLabel !== ""
      )
        return false;

      // Check if sounds array is already letters (not words)
      const words = assessment.Body.split(",");
      if (sounds.length > words.length) return false; // Already split

      return true;
    };

    const initiateCLSandWWR = (numRows, words) => {
      // ✅ Calculate maximum scores for each row
      const maxCLSScores = [];
      const maxWWRScores = [];

      for (let rowId = 0; rowId < numRows; rowId++) {
        const rowStart = rowId * assessment.Groups;
        const rowEnd = Math.min(rowStart + assessment.Groups, words.length);

        // CLS Max Score: Total letters in this row
        const rowCLSMax = words
          .slice(rowStart, rowEnd)
          .reduce((sum, word) => sum + word.length, 0);

        // WWR Max Score: Total words in this row
        const rowWWRMax = rowEnd - rowStart;

        maxCLSScores.push(rowCLSMax);
        maxWWRScores.push(rowWWRMax);
      }
      return { maxCLSScores, maxWWRScores };
    };

    if (shouldSplitIntoLetters()) {
      const words = assessment.Body.split(",");
      const allLetters = [];
      const wordLengths = [];

      // Process each word
      words.forEach((word) => {
        const letters = word.split("");
        allLetters.push(...letters);
        wordLengths.push(letters.length);
      });

      // Create labels for each letter
      const letterLabels = new Array(allLetters.length).fill("0");

      // Calculate CLS/WWR array size
      const numRows = Math.ceil(words.length / assessment.Groups);

      setRowCount(numRows);
      setSounds(allLetters);
      setSoundsLength(wordLengths);
      setSoundsLabel(letterLabels);

      // Initialize CLS and WWR scores based on the number of rows and words
      const { maxCLSScores, maxWWRScores } = initiateCLSandWWR(numRows, words);
      setCLS(maxCLSScores);
      setWWR(maxWWRScores);
    }
  }, [assessment, assessmentResults]);

  // 1. First useEffect: Calculate WWR and CLS scores whenever soundsLabel, sounds, soundsLength, or checkBox change
  useEffect(() => {
    if (soundsLabel.length && sounds.length && soundsLength.length) {
      // Find endmark position
      const endMarkIndex = soundsLabel.findIndex(
        (val) => val === "4" || val === 4,
      );

      // Calculate number of rows
      const numRows = Math.ceil(
        assessment.Body.split(",").length / assessment.Groups,
      );

      // Initialize new score arrays
      const newCLS = [...cls];
      const newWWR = [...wwr];

      // Process each row
      for (let rowId = 0; rowId < numRows; rowId++) {
        const rowStart = rowId * assessment.Groups;
        const rowEnd = Math.min(
          rowStart + assessment.Groups,
          assessment.Body.split(",").length,
        );

        let clsScore = 0;
        let wwrScore = 0;

        // Calculate scores for each word in this row
        for (let wordIndex = rowStart; wordIndex < rowEnd; wordIndex++) {
          if (wordIndex < soundsLength.length) {
            // Get word letter range
            const wordLetterStart = sum(wordIndex);
            const wordLetterEnd =
              sum(wordIndex) + parseInt(soundsLength[wordIndex]);

            // Calculate CLS - Always based on letter correctness, never affected by checkbox
            let correctCharactersInThisWord = 0;

            // Check each letter/unit for CLS calculation (independent of checkbox)
            for (
              let letterIndex = wordLetterStart;
              letterIndex < wordLetterEnd;
              letterIndex++
            ) {
              if (letterIndex < soundsLabel.length) {
                // Only count if letter is before end mark (or no end mark exists)
                if (endMarkIndex === -1 || letterIndex <= endMarkIndex) {
                  const letterStatus = parseInt(soundsLabel[letterIndex]);

                  // Count correct characters for CLS
                  if (
                    letterStatus === 1 ||
                    letterStatus === 3 ||
                    letterStatus === 0
                  ) {
                    correctCharactersInThisWord += sounds[letterIndex].length;
                  }
                }
              }
            }

            // Add correct characters to CLS score (always)
            clsScore += correctCharactersInThisWord;

            // WWR calculation - Check for checkbox override first
            if (
              wordIndex < checkBox.length &&
              checkBox[wordIndex] !== undefined
            ) {
              // If checkbox is checked, count for WWR
              if (checkBox[wordIndex]) {
                wwrScore++;
              }
              // Skip automatic WWR calculation for this word if manually overridden
              continue;
            }

            // Automatic WWR calculation for words without override
            let wordIsCorrect = true;

            // Check if this word has combined letters, if so, skip correctness check
            const hasCombinedLetters = sounds
              .slice(wordLetterStart, wordLetterEnd)
              .some((letter) => letter.length > 1);

            if (hasCombinedLetters) {
              wordIsCorrect = false;
            } else {
              // Check each letter/unit in the word for WWR
              for (
                let letterIndex = wordLetterStart;
                letterIndex < wordLetterEnd;
                letterIndex++
              ) {
                if (letterIndex < soundsLabel.length) {
                  // Only count if letter is before end mark (or no end mark exists)
                  if (endMarkIndex === -1 || letterIndex <= endMarkIndex) {
                    const letterStatus = parseInt(soundsLabel[letterIndex]);

                    // Word fails if any unit is incorrect (2) or skipped (5) or Self Correction (SC) (3)
                    if (
                      letterStatus === 2 ||
                      letterStatus === 5 ||
                      letterStatus === 3
                    ) {
                      wordIsCorrect = false;
                      break;
                    }
                  } else {
                    // Letters after end mark = word incomplete
                    wordIsCorrect = false;
                    break;
                  }
                }
              }
            }

            // Calculate the actual word length
            const actualWordLength = sounds
              .slice(wordLetterStart, wordLetterEnd)
              .reduce((sum, unit) => sum + unit.length, 0);

            // Add to WWR if word is correct (and all characters are correct)
            if (
              wordIsCorrect &&
              correctCharactersInThisWord === actualWordLength
            ) {
              wwrScore++; // Count this word for WWR
            }
          }
        }

        // Update scores for this row
        newCLS[rowId] = clsScore;
        newWWR[rowId] = wwrScore;
      }

      // Update UI display for CLS and WWR
      setCLS(newCLS);
      setWWR(newWWR);

      // Calculate totals for display
      const totalCLS = newCLS.reduce((sum, score) => sum + (score || 0), 0);
      const totalWWR = newWWR.reduce((sum, score) => sum + (score || 0), 0);

      setValues({
        totalCLS: totalCLS,
        totalWWR: totalWWR,
      });
    }
  }, [soundsLabel, sounds, soundsLength, checkBox]);

  // 2. Second useEffect: Calculate word correctness for checkmarks whenever soundsLabel, sounds, soundsLength, or checkBox change
  useEffect(() => {
    if (soundsLabel.length && sounds.length && soundsLength.length) {
      // Find endmark position
      const endMarkIndex = soundsLabel.findIndex(
        (val) => val === "4" || val === 4,
      );

      const newWordCorrectness = [];

      // Process each word
      for (let wordIndex = 0; wordIndex < soundsLength.length; wordIndex++) {
        // CHECK FOR CHECKBOX OVERRIDE FIRST
        if (wordIndex < checkBox.length && checkBox[wordIndex] !== undefined) {
          // Use the manually set checkbox value instead of calculating
          newWordCorrectness[wordIndex] = checkBox[wordIndex];
          continue;
        }

        // Continue with normal calculation for words without checkbox override
        const wordLetterStart = sum(wordIndex);
        const wordLetterEnd =
          sum(wordIndex) + parseInt(soundsLength[wordIndex]);

        // Check if this word has combined letters, if so, skip correctness check
        const hasCombinedLetters = sounds
          .slice(wordLetterStart, wordLetterEnd)
          .some((letter) => letter.length > 1);

        if (hasCombinedLetters) {
          newWordCorrectness[wordIndex] = false; // Word with combined letters is not correct
          continue;
        }

        let isWordCorrect = true;

        // Check each letter in the word
        for (
          let letterIndex = wordLetterStart;
          letterIndex < wordLetterEnd;
          letterIndex++
        ) {
          if (letterIndex < soundsLabel.length) {
            // Only check if letter is before end mark (or no end mark exists)
            if (endMarkIndex === -1 || letterIndex <= endMarkIndex) {
              const letterStatus = parseInt(soundsLabel[letterIndex]);

              // Word fails if any letter is incorrect (2) or skipped (5) or Self Correction (SC)
              if (
                letterStatus === 2 ||
                letterStatus === 5 ||
                letterStatus === 3
              ) {
                isWordCorrect = false;
                break;
              }
            } else {
              // Letters after end mark = word incomplete
              isWordCorrect = false;
              break;
            }
          }
        }

        newWordCorrectness[wordIndex] = isWordCorrect;
      }

      setWordCorrectness(newWordCorrectness);
    }
  }, [soundsLabel, sounds, soundsLength, checkBox]);

  // Effect to check endmark Validation Task
  useEffect(() => {
    if (soundsLabel?.length) {
      validateEndMark(soundsLabel);
    }
  }, [soundsLabel]);

  return (
    <form className="w-80 mx-auto" onSubmit={(e) => onSubmit(e)}>
      <table className=" table bg-light">
        {isAuthenticated && (
          <thead>
            <tr>
              {format(assessment).map((item, id) => {
                if (id < assessment.Groups) {
                  return <th></th>;
                }
              })}
              <th>CLS</th>
              <th>WWR</th>
            </tr>
          </thead>
        )}
        <tbody className="w-100">
          {format(assessment).map((item, id) => {
            return (
              <tr key={id} className="w-100">
                {/* Words Area */}
                {soundsLength.map((length, ind) => {
                  if (ind >= item && ind < (id + 1) * assessment.Groups)
                    return (
                      <td
                        key={ind}
                        className="text-center align-middle py-5"
                        style={{ border: "1px solid #ccc" }}
                      >
                        {sounds
                          .slice(sum(ind), sum(ind) + parseInt(length))
                          .map((letter, i) => (
                            <span key={parseInt(ind + "" + i)}>
                              {/* Click Trigger 
                            - 0: No response
                            - 1: Incorrect response
                            - 2: Self Correction
                            - 3: Skipped

                            * No Click Trigger for End Mark
                            Current letters[id]
                            = 0: No response
                            = 1: Incorrect response
                            = 2: Self Correction
                            = 4: End mark
                            = 5: Skipped
                            */}
                              <ContextMenuTrigger
                                id={
                                  "same_unique_identifier" +
                                  parseInt(ind + "" + i)
                                }
                              >
                                <span
                                  className="d-inline-flex align-items-center"
                                  style={{
                                    minWidth: "1.2em",
                                  }}
                                  onClick={() => {
                                    if (isAuthenticated && !done) {
                                      const index = sum(ind) + i;
                                      const timeout = soundsLabel.indexOf("4");
                                      if (index <= timeout || timeout === -1) {
                                        let temp = [...soundsLabel];
                                        if (
                                          parseInt(soundsLabel[index]) === 0
                                        ) {
                                          temp[index] = 2 + "";
                                        } else if (
                                          parseInt(soundsLabel[index]) === 1
                                        ) {
                                          temp[index] = 3 + "";
                                          if (
                                            parseInt(soundsLength[ind]) === 1
                                          ) {
                                          }
                                        }
                                        // Logic for skipped
                                        else if (
                                          parseInt(soundsLabel[index]) === 3
                                        ) {
                                          temp[index] = 5 + "";
                                          if (
                                            parseInt(soundsLength[ind]) === 1
                                          ) {
                                          }
                                        } else if (
                                          parseInt(soundsLabel[index]) === 2
                                        ) {
                                          temp[index] = 3 + "";
                                          if (
                                            parseInt(soundsLength[ind]) === 1
                                          ) {
                                          }
                                        } else {
                                          temp[index] = 0 + "";
                                        }
                                        setSoundsLabel(temp);

                                        let score = 0;
                                        for (
                                          let j = countRow(id);
                                          j < countRow(id + 1);
                                          j++
                                        ) {
                                          if (
                                            parseInt(temp[j]) === 1 ||
                                            parseInt(temp[j]) === 3
                                          ) {
                                            score += sounds[j].length;
                                          }
                                        }

                                        let arr = cls;
                                        arr[id] = score;
                                        setCLS(arr);
                                      }
                                    }
                                  }}
                                >
                                  {parseInt(soundsLabel[sum(ind) + i]) ===
                                    4 && (
                                    <span>
                                      <b style={{ color: "#FAA525" }}>]</b>
                                      <span className="time-out px-1   d-inline-flex align-items-center justify-content-center">
                                        {letter}
                                      </span>
                                    </span>
                                  )}
                                  {parseInt(soundsLabel[sum(ind) + i]) ===
                                    0 && (
                                    <span className="time-out px-1   d-inline-flex align-items-center justify-content-center">
                                      {letter}
                                    </span>
                                  )}

                                  {/* id=3 Self-correct Box */}
                                  {parseInt(soundsLabel[sum(ind) + i]) ===
                                    3 && (
                                    <span className="position-relative">
                                      <div
                                        style={{
                                          position: "absolute",
                                          display: "inline-block",
                                          bottom: "100%",
                                          left: "0",
                                          top: "-2em",
                                        }}
                                        className=" w-100 text-center"
                                      >
                                        <span className="self-correct px-1   d-inline-flex align-items-center justify-content-center">
                                          <span>SC</span>
                                        </span>
                                      </div>
                                      <span className="button-non">
                                        {letter}
                                      </span>
                                    </span>
                                  )}

                                  {/* id=1 Correct Box */}
                                  {parseInt(soundsLabel[sum(ind) + i]) ===
                                    1 && <span className="">{letter}</span>}

                                  {/* id=2 Incorrect Box */}
                                  {parseInt(soundsLabel[sum(ind) + i]) ===
                                    2 && (
                                    <span className="position-relative">
                                      <div
                                        style={{
                                          position: "absolute",
                                          display: "inline-block",
                                          bottom: "100%",
                                          left: "0",
                                          top: "-2em",
                                        }}
                                        className=" w-100 text-center"
                                      >
                                        <span className="incorrect px-1   d-inline-flex align-items-center justify-content-center">
                                          <span>/</span>
                                        </span>
                                      </div>
                                      <span className="button-non">
                                        {letter}
                                      </span>
                                    </span>
                                  )}

                                  {/* id=5 Skip Box */}
                                  {parseInt(soundsLabel[sum(ind) + i]) ===
                                    5 && (
                                    <span className="position-relative">
                                      <div
                                        style={{
                                          position: "absolute",
                                          display: "inline-block",
                                          bottom: "100%",
                                          left: "0",
                                          top: "-2em",
                                        }}
                                        className=" w-100 text-center"
                                      >
                                        <span className="skip px-1   d-inline-flex align-items-center justify-content-center">
                                          <span>-</span>
                                        </span>
                                      </div>
                                      <span className="button-non">
                                        {letter}
                                      </span>
                                    </span>
                                  )}
                                </span>{" "}
                              </ContextMenuTrigger>

                              {/* Move the + icon OUTSIDE the ContextMenuTrigger */}
                              {isAuthenticated &&
                                parseInt(soundsLength[ind]) > 1 && // this word has more than 1 letter
                                i < parseInt(soundsLength[ind]) - 1 && ( //NOT on the last letter of the word
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25"
                                    height="25"
                                    fill="currentColor"
                                    className="bi bi-plus add-item-btn rounded-circle border border-primary txt-primary border-2"
                                    viewBox="0 0 16 16"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                      e.stopPropagation();

                                      const index = sum(ind) + i;
                                      const timeout = soundsLabel.indexOf("4");
                                      if (index <= timeout || timeout === -1) {
                                        if (parseInt(soundsLength[ind]) > 1) {
                                          if (
                                            i <
                                            parseInt(soundsLength[ind]) - 1
                                          ) {
                                            combine(index, true, ind);
                                          } else {
                                            combine(index, false, ind);
                                          }
                                        }
                                      }
                                    }}
                                  >
                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                  </svg>
                                )}

                              {/* Menu Context */}
                              {isAuthenticated && !done && (
                                <ContextMenu
                                  id={
                                    "same_unique_identifier" +
                                    parseInt(ind + "" + i)
                                  }
                                  className="card react-contextmenu p-1"
                                >
                                  {/*id=4 End Mark */}
                                  <MenuItem
                                    onClick={() => {
                                      // ✅ Fix the variable scope - use correct indices
                                      const index = sum(ind) + i; // ✅ Use 'ind' (word index) and 'i' (letter index)
                                      const timeout = soundsLabel.indexOf("4");

                                      // ✅ Check if we can place end mark at this position

                                      let temp = [...soundsLabel];

                                      for (let j = 0; j < temp.length; j++) {
                                        if (parseInt(temp[j]) === 4) {
                                          temp[j] = "0"; //
                                        }
                                      }
                                      temp[index] = "4";
                                      setSoundsLabel(temp);
                                    }}
                                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                                  >
                                    <span
                                      style={{ color: "#FAA525" }}
                                      className="time-out px-1   d-inline-flex align-items-center justify-content-center"
                                    >
                                      <b> ]</b>
                                    </span>
                                    <span>
                                      <b>End Mark</b>
                                    </span>
                                  </MenuItem>

                                  {/* id=2 Incorrect */}
                                  <MenuItem
                                    onClick={() => {
                                      const index = sum(ind) + i; // ✅ Fixed: was sum(i) + id
                                      const timeout = soundsLabel.indexOf("4");
                                      if (index <= timeout || timeout === -1) {
                                        let temp = [...soundsLabel];
                                        temp[index] = "2";
                                        setSoundsLabel(temp);
                                      }
                                    }}
                                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                                  >
                                    <span className="incorrect px-1 d-flex align-items-center justify-content-center">
                                      /
                                    </span>
                                    <span>
                                      <b>Incorrect Response (error)</b>
                                    </span>
                                  </MenuItem>

                                  {/* id=3 Self Correction */}
                                  <MenuItem
                                    onClick={() => {
                                      const index = sum(ind) + i; // ✅ Fixed: was sum(i) + id
                                      const timeout = soundsLabel.indexOf("4");
                                      if (index <= timeout || timeout === -1) {
                                        let temp = [...soundsLabel];
                                        temp[index] = "3";
                                        setSoundsLabel(temp);
                                      }
                                    }}
                                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                                  >
                                    <span className="self-correct px-1 txt-primary d-inline-flex align-items-center justify-content-center">
                                      SC
                                    </span>
                                    <span>
                                      <b>Self Correction (no error)</b>
                                    </span>
                                  </MenuItem>

                                  {/* id=5 Skip */}
                                  <MenuItem
                                    onClick={() => {
                                      const index = sum(ind) + i; // ✅ Fixed: was sum(i) + id
                                      const timeout = soundsLabel.indexOf("4");
                                      if (index <= timeout || timeout === -1) {
                                        let temp = [...soundsLabel];
                                        temp[index] = "5";
                                        setSoundsLabel(temp);
                                      }
                                    }}
                                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                                  >
                                    <span className="skip px-1 d-inline-flex align-items-center justify-content-center">
                                      -
                                    </span>
                                    <span>
                                      <b>Skipped (error)</b>
                                    </span>
                                  </MenuItem>

                                  {/* Separate */}
                                  <MenuItem
                                    onClick={() => {
                                      const index = sum(ind) + i; // ✅ Fixed: was sum(i) + id
                                      const arr = sounds[index].split("");
                                      const timeout = soundsLabel.indexOf("4");
                                      if (index <= timeout || timeout === -1) {
                                        if (arr.length > 1) {
                                          separate(arr, index, ind);
                                        }
                                      }
                                    }}
                                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                                  >
                                    <span className="time-out px-1 d-inline-flex align-items-center justify-content-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="red"
                                        className="bi bi-dash-lg"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"
                                        />
                                      </svg>
                                    </span>
                                    <span className="px-3">
                                      <b>Separate</b>
                                    </span>
                                  </MenuItem>

                                  {/* Cancel*/}
                                  <MenuItem
                                    onClick={() => {
                                      const index = sum(ind) + i; // ✅ Fixed: was sum(i) + id
                                      const timeout = soundsLabel.indexOf("4");
                                      if (index <= timeout || timeout === -1) {
                                        let temp = [...soundsLabel];
                                        temp[index] = "0";
                                        setSoundsLabel(temp);
                                      }
                                    }}
                                    className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                                  >
                                    <span className="time-out px-1 d-inline-flex align-items-center justify-content-center"></span>
                                    <span>
                                      <b>Cancel</b>
                                    </span>
                                  </MenuItem>
                                </ContextMenu>
                              )}
                            </span>
                          ))}

                        {/* Checkbox for each word correction */}
                        <div className="d-flex justify-content-center mt-1">
                          <input
                            onChange={(e) => {
                              let newCheckBox = [...checkBox];
                              newCheckBox[ind] = e.target.checked;
                              setCheckbox(newCheckBox);
                            }}
                            type="checkbox"
                            id={`word-checkbox-${ind}`}
                            className="form-check-input"
                            style={{
                              width: "18px",
                              height: "18px",
                              cursor: "pointer",
                            }}
                            checked={
                              checkBox[ind] !== undefined
                                ? checkBox[ind]
                                : wordCorrectness[ind] || false
                            }
                          />
                        </div>
                      </td>
                    );
                })}

                {/* CLS Score */}
                {isAuthenticated && (
                  <td className="align-middle py-5">
                    <input
                      type="number"
                      required
                      disabled
                      readOnly={true}
                      value={cls[id] === undefined ? 0 : cls[id]}
                      className="form-control form-silly mr-2 d-inline px-0 text-center "
                    />
                    &nbsp;&nbsp;/&nbsp;
                    {
                      assessment.Body.split(",")
                        .slice(item, (id + 1) * assessment.Groups)
                        .join("").length
                    }
                  </td>
                )}

                {/* WWR Score */}
                {isAuthenticated && (
                  <td className="align-middle py-5">
                    <input
                      type="number"
                      required
                      disabled
                      readOnly={true}
                      onChange={(e) => {
                        let arr = [...wwr];
                        arr[id] = parseInt(e.target.value);
                        setWWR(arr);
                      }}
                      value={wwr[id] === undefined ? 0 : wwr[id]}
                      className="form-control form-silly mr-2 d-inline px-0 text-center"
                    />
                    &nbsp;&nbsp;/&nbsp;{" "}
                    {
                      assessment.Body.split(",").slice(
                        item,
                        (id + 1) * assessment.Groups,
                      ).length
                    }
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {isAuthenticated && (
        <Fragment>
          <div class="form-floating my-2">
            <textarea
              onChange={(e) => SetComment(e.target.value)}
              class="form-control"
              placeholder="Leave a comment here"
              value={comment}
              readOnly={location.pathname.includes("/assessment/preview/")}
              id="floatingTextarea2"
              style={{ height: "100px" }}
            ></textarea>
            <label for="floatingTextarea2">Comments</label>
          </div>
          <div
            className={`d-flex align-items-center justify-content-${
              !done ? "end" : "between"
            } my-3`}
          >
            {done && (
              <div className="">
                Total Correct Letter Sounds (CLS):{" "}
                <span className="txt-primary">
                  <b>{values.totalCLS}</b>
                </span>{" "}
                <br />
                Total Whole Word Read (WWR):{" "}
                <span className="txt-primary">
                  <b>{values.totalWWR}</b>
                </span>
                {/*<br />
                Total Score:{' '}
                <span className='txt-primary'>
                  <b>{totalScore}</b>
                </span>*/}
              </div>
            )}
            {!viewAssessment && (
              <div className="d-flex align-items-center justify-content-end mb-2  p-2">
                {done && (
                  <button
                    className="button-primary btn-block btn px-5 mx-2"
                    type="reset"
                    onClick={() => {
                      setDone(false);
                      setDoneCurrent(false);
                    }}
                  >
                    Edit
                  </button>
                )}

                {!done && (
                  <button
                    className="button-primary btn-block btn px-5 mx-2"
                    type="reset"
                    onClick={(e) => {
                      e.preventDefault(); // prevent browser default reset

                      // First, separate any combined letters
                      const originalWords = assessment.Body.split(",");
                      const originalLetters = [];
                      const originalWordLengths = [];

                      // Process each word to get original letters
                      originalWords.forEach((word) => {
                        const letters = word.split("");
                        originalLetters.push(...letters);
                        originalWordLengths.push(letters.length);
                      });

                      // Reset to original state
                      setSounds(originalLetters);
                      setSoundsLength(originalWordLengths);
                      setSoundsLabel(zeros(originalLetters));

                      // Reset checkboxes
                      setCheckbox([]);

                      // Reset WWR scores
                      const emptyWWR = new Array(
                        Math.ceil(originalWords.length / assessment.Groups),
                      ).fill(0);
                      setWWR(emptyWWR);

                      // Reset CLS scores
                      const emptyCLS = new Array(
                        Math.ceil(originalWords.length / assessment.Groups),
                      ).fill(0);
                      setCLS(emptyCLS);

                      // Reset word correctness
                      setWordCorrectness([]);

                      // Reset combined letters tracking
                      setCombinedLetters(new Set());

                      // Reset totals
                      setValues({
                        totalCLS: 0,
                        totalWWR: 0,
                      });

                      setDone(false);
                      setDoneCurrent(false);

                      // Force update
                      forceUpdate();
                    }}
                  >
                    Clear
                  </button>
                )}

                {!done ? (
                  <div
                    className="button-primary btn-block btn px-5"
                    onClick={(e) => {
                      setRestartKey(restartKey + 1);
                      setPlay(false);
                      setDone(true);
                      setDoneCurrent(true);
                      forceUpdate();
                    }}
                  >
                    Save
                  </div>
                ) : (
                  <button
                    className="button-primary btn-block btn px-5"
                    type="submit"
                  >
                    Submit
                  </button>
                )}

                {/* Delete Button */}
                {/* Delete Modal */}
                <Modal
                  show={showDeleteModal}
                  onHide={() => setShowDeleteModal(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Delete Assigned Assessment</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure you want to delete assigned assessment?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => {
                        deletePMResult(
                          assessmentResults.ResultID,
                          assessmentResults.StudentID,
                          assessment.CategoryID,
                        )
                          .then(() => {
                            setStartAssessment(false);
                            setShowDeleteModal(false);
                          })
                          .catch(() => {
                            setShowDeleteModal(false);
                          });
                      }}
                    >
                      Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Delete Button */}
                <Button
                  variant="danger"
                  className="d-flex align-items-center px-4 mx-2"
                  onClick={() => setShowDeleteModal(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash-fill me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                  Delete
                </Button>

                {/* Warning Modal */}
                {/* ✅ Replace the Bootstrap modal with React Bootstrap Modal */}
                <Modal
                  show={showWarning}
                  onHide={() => setShowWarning(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Submission Failed!</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Missing end mark! Please add an end mark (]) before
                    submitting.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowWarning(false)}
                    >
                      OK, I'll add the end mark
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            )}
          </div>
        </Fragment>
      )}
    </form>
  );
};

export default AssessmentSilly;
